<template lang="pug">
  include /mixins
  +b.d-control-input__icon.--append(
    @click.prevent='appendIconFunc',
    :class="appendIcon"
  )
    slot(name="appendIcon")
</template>
<script>
export default {
  name: 'AppendComponent',
  props: {
    appendIcon: {},
    appendIconFunc: {
      type: Function,
      default: () => {},
    },
  },
}
</script>
